class ViewAsSwitcher extends HTMLElement {
	constructor() {
		super();
		this.buttons = Array.from(this.querySelectorAll(".view-as__option"));
		this.buttons.forEach((button) => {
			button.addEventListener("click", this.onOptionClick.bind(this));
		});
		this.syncActiveState();
	}

	get currentColumns() {
		var stored = document.documentElement.dataset.gridCols;
		return this.allowedColumns.indexOf(stored) !== -1 ? stored : "4";
	}

	get allowedColumns() {
		return ["2", "3", "4"];
	}

	syncActiveState() {
		var current = this.currentColumns;
		this.buttons.forEach((button) => {
			var isActive = button.dataset.columns === current;
			button.classList.toggle("view-as__option--active", isActive);
			button.setAttribute("aria-pressed", isActive);
		});
	}

	onOptionClick(event) {
		var columns = event.currentTarget.dataset.columns;
		if (this.allowedColumns.indexOf(columns) === -1) return;

		document.documentElement.dataset.gridCols = columns;
		try {
			localStorage.setItem("YJ-collection-grid-columns", columns);
		} catch (err) {}

		this.syncActiveState();
	}
}

customElements.define("view-as-switcher", ViewAsSwitcher);
